import { StringUtils } from "../../../../Global/Base/Utils/StringUtils";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";
/**
 * Vytvoří textový element obsahující předaný text
 * @includeToDoc
 */
export class StringBuilder implements IContentBuilder {
    private _text: string = "";

    constructor(text: string) {
        this._text = text;
    }

    public build(): Promise<HTMLElement> {
        return Promise.resolve(createElement({
            html: StringUtils.stringToHTMLText(this._text),
        }));
    }
}
